export enum TableHeaderButtonActionStatus {
  EXECUTING = 'executing',
  DONE = 'done',
  ERROR = 'error',
  SUCCESS = 'success'
}
